<template>
  <b-card
    class="boxNews mb-1 "
    style="height: 100%; max-height: 415px;"
    no-body
  >
    <b-card-header class="p-1 backgroundCardHeader">
      <div class="col-12 p-0 row d-flex">
        <div class="col-10">
          <h3 class="card-title justify-content-start">
            <router-link
              :to="{ name: 'home-category', params: { slug: 'video' } }"
              class="d-flex align-items-center"
              title="Tin video"
            > <span class="tinvideo" /> <span class="font-be-vietnam font-size20-be-vietnam text-dark font-weight-700 ml-1">Tin video </span></router-link>
          </h3>
        </div>
        <div class="col-2">
          <router-link :to="{ name: 'home-category', params: { slug: 'video' } }">
            <span class="default_arrow justify-content-end ml-auto" />
          </router-link>
        </div>
      </div>
    </b-card-header>
    <b-card-body class="p1 mediaSlide">
      <swiper
        class="swiper-autoplay homeSwipper font-category"
        :options="swiperOptions"
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
      >
        <swiper-slide
          v-for=" (data, index) in items"
          :key="index"
        >
          <div class="itemSwiper">
            <router-link
              :to="{ name: 'home-view', params: { id: data.id, slug: data.slug } }"
              class="thumbnail"
              :title="data.title"
            >
              <b-img
                class="img_thumbnail"
                :src="data.image"
              />
            </router-link>

            <h3 class="news-title text-left mt-1 d-flex">
              <router-link
                :to="{ name: 'home-view', params: { id: data.id, slug: data.slug } }"
                :title="data.title"
                class=" trunc trunc-2 trunc-3"
                :class="renderClassTitleHot(data)"
              >{{ data.title }}
                <span
                  v-if="data.hot"
                  class="iconHotGif"
                />
                <span
                  v-if="data.is_get"
                  class="iconNewsRead"
                /></router-link>

            </h3>
            <div class="news-icon row w-100 ">
              <div class="w-30 d-flex pl-1">
                <span
                  v-for=" (type, key) in data.content_type"
                  :key="key"
                  class="d-flex justify-content-between pr-5px"
                >
                  <span
                    v-if="type === 'audio'"
                    class="iconAudioBlue"
                  />
                  <span
                    v-if="type === 'photo'"
                    class="iconPhotoBlue"
                  />
                  <span
                    v-if="type === 'video'"
                    class="iconVideoBlue"
                  />
                </span>
              </div>
              <div
                class="w-70 d-flex show_author_and_time justify-content-end"
                style="white-space: nowrap"
              >
                <span class="font-size13-be-vietnam"><span class="mr-1">{{ (data.timeago) }}</span></span>
                <!-- <span v-if="data.unit">{{ showListPart(data.unit) }}</span> -->
                <span
                  v-if="data.unit"
                  class="icon font-size13-be-vietnam"
                > <span style="padding-left: 10px;">{{ showListPart(data.unit) }}</span> </span>
              </div>
            </div>
          </div>
        </swiper-slide>
        <div
          slot="button-next"
          class="swiper-button-next"
        />
        <div
          slot="button-prev"
          class="swiper-button-prev"
        />
        <div
          slot="pagination"
          class="swiper-pagination mySwiper"
        />
      </swiper>
    </b-card-body>
  </b-card>
</template>
<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import {
  BCardBody,
  BCard,
  BImg,
  BCardHeader,
} from 'bootstrap-vue';
import { timeago } from '@/libs/helper';
import 'swiper/css/swiper.css'

export default {
  components: {
    Swiper,
    SwiperSlide,
    BCard,
    BCardBody,
    BImg,
    BCardHeader,
  },
  props: {
    items: {
      type: Array,
      default: Array,
    },
  },
  data() {
    return {
      dialog_title: 'Thêm mới',
      dataEdit: {},
      itemView: {},
      swiperOptions: {
        spaceBetween: 30,
        centeredSlides: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
          renderBullet(index, className) {
            return `<span class="${className}">${index + 1}</span>`;
          },
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
      },

    };
  },
  setup(props, context) {
    // const swiperOption = ref({
    //   slidesPerView: 4,
    //   spaceBetween: 10,

    //   navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    //   },
    //   breakpoints: {
    //     1024: {
    //       slidesPerView: props.itemSlide ? props.itemSlide : 4,
    //       spaceBetween: 15,
    //     },
    //     768: {
    //       slidesPerView: 3,
    //       spaceBetween: 15,
    //     },
    //     640: {
    //       slidesPerView: 2,
    //       spaceBetween: 10,
    //     },
    //     320: {
    //       slidesPerView: 1,
    //       spaceBetween: 10,
    //     },
    //   },
    // });
    // return {
    //   swiperOption,
    // }
  },
  methods: {
    resolveTimeago(time) {
      return timeago(time);
    },
    showListPart(str) {
      return str.split(',').slice(0, 3).join(',');
    },
    renderClassTitleHot(item) {
      // 1. Tin bình thường mầu đen

      // 2. Tin đã click màu ghi
      // 3. Tin hot màu đỏ tười có iconhot
      // 4. TIn đã lấy màu nâu đỏ có icon xanh
      // 5. Tin hot đã click màu ghi có icon hot
      // 6. TIn hot đã lấy màu nâu đỏ có icon xanh, icon hot
      let classTitle = 'class_title_normall';
      if (item.hot) {
        if (item.is_get) { // đã lấy thì đã đọc
          if (item.is_view) {
            classTitle = 'class_title_hot_get_view'
          } else {
            classTitle = 'class_title_hot_get_notview'
          }
        } else if (!item.is_get) { // tin chưa lấy những có thể đọc hoặc chưa đọc
          if (item.is_view) {
            classTitle = 'class_title_hot_notget_view'
          } else {
            classTitle = 'class_title_hot_notget_notview' // tin hot chưa lấy chưa đọc
          }
        }
      } else if (!item.hot) {
        if (item.is_get) { // tin đã lấy thì đã đọc
          if (item.is_view) {
            classTitle = 'class_title_nothot_get_view'
          } else {
            classTitle = 'class_title_nothot_notget_notview'
          }
        } else if (!item.is_get) {
          if (item.is_view) { // tin bt nhưng đã xem chưa lấy
            classTitle = 'class_title_nohot_notget_view'
          } else {
            classTitle = 'class_title_nohot_notget_notview'
          }
        }
      }

      return classTitle;
    },
  },
}
</script>
